/**
 * Get the response initial state from questions
 *
 * @param {{questionId: string, isMandatory: boolean}[]} questionnaire
 * @returns {{
 *    answers: { id: string, isMandatory: boolean, answer: any }[]
 * }}
 */
const getFeedbackResponseInitialState = (questionnaire) => {
  const answers = questionnaire.map(({ questionId, isMandatory }) => ({
    id: questionId,
    isMandatory,
    answer: null,
  }));
  return {
    answers,
  };
};

export default getFeedbackResponseInitialState;
